export default "__VITE_ASSET__b30b5552__"